/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Categories1 } from './Categories1';
import {
    Categories1FromJSON,
    Categories1FromJSONTyped,
    Categories1ToJSON,
} from './Categories1';

/**
 * 
 * @export
 * @interface MonitEntityStatsVulnerabilitiesSpecific
 */
export interface MonitEntityStatsVulnerabilitiesSpecific {
    /**
     * 
     * @type {number}
     * @memberof MonitEntityStatsVulnerabilitiesSpecific
     */
    count?: number;
    /**
     * 
     * @type {Categories1}
     * @memberof MonitEntityStatsVulnerabilitiesSpecific
     */
    categories?: Categories1;
}

/**
 * Check if a given object implements the MonitEntityStatsVulnerabilitiesSpecific interface.
 */
export function instanceOfMonitEntityStatsVulnerabilitiesSpecific(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityStatsVulnerabilitiesSpecificFromJSON(json: any): MonitEntityStatsVulnerabilitiesSpecific {
    return MonitEntityStatsVulnerabilitiesSpecificFromJSONTyped(json, false);
}

export function MonitEntityStatsVulnerabilitiesSpecificFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityStatsVulnerabilitiesSpecific {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': !exists(json, 'count') ? undefined : json['count'],
        'categories': !exists(json, 'categories') ? undefined : Categories1FromJSON(json['categories']),
    };
}

export function MonitEntityStatsVulnerabilitiesSpecificToJSON(value?: MonitEntityStatsVulnerabilitiesSpecific | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'categories': Categories1ToJSON(value.categories),
    };
}

